import { QUERY_KEYS, SECOND } from './index';
import { API_ROUTES } from './apiRoutes';

export const FINPSP_CURRENCY = 'BDT';

export const FINPSP_PAYMENT_POLL_INTERVAL = 5 * SECOND;

export const FINPSP_PAYMENT_QUERY_KEYS = [
  QUERY_KEYS.balance,
  API_ROUTES.WALLET_TRANSACTIONS_HISTORY.PLAYER,
  QUERY_KEYS.walletTransactions,
  QUERY_KEYS.walletTransactionTotals,
];

export const FINPSP_BANK_TYPE = {
  BKASH: 'Bkash',
  NAGAD: 'Nagad',
  UPAY: 'Upay',
  ROCKET: 'Rocket',
} as const;

export type FinpspBankType = (typeof FINPSP_BANK_TYPE)[keyof typeof FINPSP_BANK_TYPE];

export const FINPSP_BANK_LABELS: Record<FinpspBankType, string> = {
  [FINPSP_BANK_TYPE.BKASH]: 'bKash',
  [FINPSP_BANK_TYPE.NAGAD]: 'Nagad',
  [FINPSP_BANK_TYPE.UPAY]: 'Upay',
  [FINPSP_BANK_TYPE.ROCKET]: 'Rocket',
};

export const FINPSP_BANK_TYPES = Object.values(FINPSP_BANK_TYPE);

export const FINPSP_ENABLED_BANK_TYPES = [FINPSP_BANK_TYPE.BKASH, FINPSP_BANK_TYPE.NAGAD] as const;

export const FINPSP_DEPOSIT_TYPE = {
  P2A: 'P2A',
  P2P: 'P2P',
  P2M: 'P2M',
  P2C: 'P2C',
} as const;

export type FinpspDepositType = (typeof FINPSP_DEPOSIT_TYPE)[keyof typeof FINPSP_DEPOSIT_TYPE];

export const FINPSP_WITHDRAWAL_TYPE = {
  P2A: 'P2A',
  P2P: 'P2P',
} as const;

export type FinpspWithdrawalType = (typeof FINPSP_WITHDRAWAL_TYPE)[keyof typeof FINPSP_WITHDRAWAL_TYPE];

export const FINPSP_WITHDRAWAL_CHANNELS = {
  P2A: { actionKey: 'finpspAgentPayout' },
  P2P: { actionKey: 'finpspSendMoney' },
} as const satisfies Record<FinpspWithdrawalType, { actionKey: string }>;

export const FINPSP_DEPOSIT_TYPE_ALIASES: Record<string, FinpspDepositType> = {
  agent: FINPSP_DEPOSIT_TYPE.P2A,
  personal: FINPSP_DEPOSIT_TYPE.P2P,
  manual_merchant: FINPSP_DEPOSIT_TYPE.P2M,
  api_merchant: FINPSP_DEPOSIT_TYPE.P2C,
};

export const FINPSP_PAYMENT_STATE = {
  CREATED: 'created',
  AWAITING_APPROVAL: 'awaiting_approval',
  SUBMITTING: 'submitting',
  PENDING: 'pending',
  SUBMISSION_UNKNOWN: 'submission_unknown',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  REVIEW: 'review',
} as const;

export const FINPSP_DEPOSIT_CHANNELS = {
  P2A: { actionKey: 'finpspCashOut', requiresCustomerNumber: true, checkout: 'instructions' },
  P2P: { actionKey: 'finpspSendMoney', requiresCustomerNumber: true, checkout: 'instructions' },
  P2M: { actionKey: 'finpspPayment', requiresCustomerNumber: true, checkout: 'instructions' },
  P2C: { actionKey: null, requiresCustomerNumber: false, checkout: 'redirect' },
} as const satisfies Record<
  FinpspDepositType,
  {
    actionKey: string | null;
    requiresCustomerNumber: boolean;
    checkout: 'instructions' | 'redirect';
  }
>;

export const FINPSP_PAYMENT_STATUS = {
  REQUESTED: 'requested',
  RESERVED: 'reserved',
  APPROVED: 'approved',
  CANCELLED: 'cancelled',
  REJECTED: 'rejected',
  PENDING: 'pending',
} as const;
